module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/社会责任.18b27c41.png";